export enum SettingsResourceCopilotDataEventObjectsEnum {
  RESOURCE_COPILOT_OPEN = 'resource_copilot_open',
  RESOURCE_COPILOT_CLOSE = 'resource_copilot_close',
}
